"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nearAPI = __importStar(require("near-api-js"));
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const errors_1 = require("@ledgerhq/errors");
const hw_1 = require("../../hw");
const operation_1 = require("../../operation");
const hw_app_near_1 = __importDefault(require("@ledgerhq/hw-app-near"));
const js_buildTransaction_1 = require("./js-buildTransaction");
const buildOptimisticOperation = (account, transaction, fee) => {
    let type;
    let value = new bignumber_js_1.BigNumber(transaction.amount);
    switch (transaction.mode) {
        case "stake":
            type = "STAKE";
            break;
        case "unstake":
            type = "UNSTAKE";
            break;
        case "withdraw":
            type = "WITHDRAW_UNSTAKED";
            break;
        default:
            value = value.plus(fee);
            type = "OUT";
    }
    const operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type,
        value,
        fee,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient].filter(Boolean),
        accountId: account.id,
        date: new Date(),
        extra: {},
    };
    return operation;
};
const signOperation = ({ account, deviceId, transaction }) => new rxjs_1.Observable(o => {
    function main() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const transport = yield (0, hw_1.open)(deviceId);
            try {
                o.next({ type: "device-signature-requested" });
                if (!transaction.fees) {
                    throw new errors_1.FeeNotLoaded();
                }
                const near = new hw_app_near_1.default(transport);
                const { publicKey } = yield near.getAddress(account.freshAddressPath);
                const unsigned = yield (0, js_buildTransaction_1.buildTransaction)(account, transaction, publicKey);
                const response = yield near.signTransaction(unsigned.encode(), account.freshAddressPath);
                const signedTransaction = new nearAPI.transactions.SignedTransaction({
                    transaction: unsigned,
                    signature: new nearAPI.transactions.Signature({
                        keyType: unsigned.publicKey.keyType,
                        data: response,
                    }),
                });
                o.next({ type: "device-signature-granted" });
                const operation = buildOptimisticOperation(account, transaction, (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0));
                const signedSerializedTx = signedTransaction.encode();
                o.next({
                    type: "signed",
                    signedOperation: {
                        operation,
                        signature: Buffer.from(signedSerializedTx).toString("base64"),
                    },
                });
            }
            finally {
                (0, hw_1.close)(transport, deviceId);
            }
        });
    }
    main().then(() => o.complete(), e => o.error(e));
});
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map